/**
 * Vuetify semantic theme colors. Use these values wherever a color is passed
 * to a Vuetify component (v-chip color, v-icon color, v-alert type, etc.) so
 * status code and UI styling stay in sync.
 */
export enum VuetifyColorEnum {
  PRIMARY = "primary",
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error"
}

/**
 * Vuetify Material palette hex values. Use these instead of raw hex strings
 * so color usage stays traceable and consistent.
 */
export enum VuetifyMaterialColorEnum {
  BLUE_GREY_DARKEN_1 = "#546E7A",
  BLUE_GREY = "#607D8B",
  GREY_DARKEN_3 = "#424242",
  GREY_DARKEN_1 = "#757575",
  GREY = "#9E9E9E",
  GREY_LIGHTEN_2 = "#E0E0E0",
  GREY_LIGHTEN_4 = "#F5F5F5",
  RED_DARKEN_1 = "#E53935",
  RED_LIGHTEN_5 = "#FFEBEE",
  ORANGE_DARKEN_1 = "#FB8C00",
  ORANGE_LIGHTEN_5 = "#FFF3E0",
  BLUE_DARKEN_1 = "#1E88E5",
  BLUE_LIGHTEN_5 = "#E3F2FD",
  DEEP_PURPLE_LIGHTEN_1 = "#7E57C2"
}
